import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import OneTimePasswordForm from '../../modules/profile/components/OneTimePasswordForm';

const OTP = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('profile->>OneTimePasswordForm.One-Time Password')} />

      <OneTimePasswordForm />
    </>
  );
};

export default OTP;
